import { render, staticRenderFns } from "./OrdersIndex.vue?vue&type=template&id=af9b5e4e&scoped=true"
import script from "./OrdersIndex.vue?vue&type=script&lang=js"
export * from "./OrdersIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9b5e4e",
  null
  
)

export default component.exports